// removed by extract-text-webpack-plugin
module.exports = {"howItWorks":"_13LxdC1_AbVjjGQdD1WqD8"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/HowItWorks.scss
// module id = 1598
// module chunks = 0